/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as React from 'react';

import { Icon } from 'sarsaparilla';

import { useMap } from '../MapContext';

import { MapControlButton } from './MapControlButton';

interface MapSatelliteToggleProps {
    gaTrackingId?: string;
    gaTrackingValue?: string;
    className?: string;
}

export function MapSatelliteToggle({
    gaTrackingId,
    gaTrackingValue,
    className,
}: MapSatelliteToggleProps) {
    const { mapInstance } = useMap();
    const [isSatelliteView, setIsSatelliteView] = React.useState(false);

    const handleToggle = () => {
        if (!mapInstance) return;

        // Guard: no-op safely when the active style has no satellite layer,
        // so the control can be rendered against styles that lack it.
        if (!mapInstance.getLayer('fixed-satellite')) return;

        setIsSatelliteView((prev) => {
            mapInstance.setLayoutProperty(
                'fixed-satellite',
                'visibility',
                prev ? 'none' : 'visible'
            );

            return !prev;
        });
    };

    return (
        <MapControlButton
            onClick={handleToggle}
            gaTrackingId={gaTrackingId}
            gaTrackingValue={gaTrackingValue}
            className={className}
            aria-label={isSatelliteView ? 'Default View' : 'Satellite View'}
        >
            <Icon iconName={isSatelliteView ? 'map' : 'satellite'} />
        </MapControlButton>
    );
}
